import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {SplitService} from "../../../commons/services/split-service.service";
import {FulfillmentPackageSplitType} from "../../types/fulfillment-package-split.type";
import {FulfillmentStepStatusType} from "../../types/fulfillment-step-status.type";


export class FulfillmentLineMetadataTableComponent implements IController {

  metadata: any;

  public isOddLength = false;

  constructor(private splitService: SplitService) {
  }

  $onInit() {
    this.isOddLength = this.metadata.length % 2 !== 0;
  }

}

angular
  .module('bringoz.admin.fulfillment')
  .component('fulfillmentLineMetadataTable', {
    bindings: {
      metadata: '<'
    },
    template: require('./fulfillment-line-metadata-table.html').default,
    controller: FulfillmentLineMetadataTableComponent
  });
